import { axiosClient } from './AxiosClient'
import axios from 'axios'
import { baseURL, oauthPrefix } from '../Network/Config'


function faq_list(callback, errorCallback){
    let url = baseURL + `/admin/faq`

    axiosClient.get(url, {
        params: {
            page: 1,
            size: 999,
            building_id: localStorage.getItem('building_id'),
            sort: 'created_date'
        }
    })
    .then((response)=>{
        let data = response.data
        callback(data)
        console.log("complete")
    })
    .catch((error)=>{
        errorCallback(error)
    })
}
function deletefaq(id, callback, errorCallback){
    let url = baseURL+"/admin/faq/"+id;

    axiosClient.delete(url)
    .then((response)=>{
        
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}
function getfaq(id, callback, errorCallback){
    let url = baseURL+"/admin/faq/"+id;

    axiosClient.get(url)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createfaq(
    question,
    answer,
    callback,
    errorCallback
){
    let url = baseURL + "/admin/faq" 

    console.log("FAQ.js")
    console.log(question)
    console.log(answer)

    const bodyData = {
        "question": question,
        "answer": answer,
        buildingId: localStorage.getItem('building_id')
    }

    let bodyJson = JSON.stringify(bodyData)

    axios.post(url, bodyJson,{
        headers:{
            "Authorization": oauthPrefix + localStorage.getItem("access_token"),
            "Content-Type": "application/json"
        }
    })
    .then((response)=>{
        callback(response.data)
        console.log("complete")
    })
    .catch((error)=>{
        console.log(error.response)
        console.log("error")
        errorCallback(error)
    })
}

function updatefaq(
    id,
    question,
    answer,
    callback,
    errorCallback
){
    let url = baseURL + "/admin/faq/" + id

    console.log("FAQ.js")
    console.log(question)
    console.log(answer)

    const bodyData = {
        "question": question,
        "answer": answer
    }

    let bodyJson = JSON.stringify(bodyData)

    axios.put(url, bodyJson,{
        headers:{
            "Authorization": oauthPrefix + localStorage.getItem("access_token"),
            "Content-Type": "application/json"
        }
    })
    .then((response)=>{
        callback()
        console.log("complete")
    })
    .catch((error)=>{
        console.log(error)
        errorCallback(error)
    })
}
export { faq_list, createfaq, updatefaq, deletefaq, getfaq}